import React from 'react';
import { css } from 'linaria';
import { styled } from 'linaria/react';
import { SectionSubTitle } from '../../section-subtitle';

type ModalMediaCardBodyProps = {
  children: React.ReactNode;
  className?: string;
  title?: string;
};

export const modalMediaCardHeader = css`
  @media (--only-mobile) {
    margin-bottom: 16px;
  }
`;

export const StyledModalMediaCardBody = styled.div`
  display: flex;
  flex-direction: column;
  width: 404px;
  padding: 32px;
  overflow-x: hidden;
  overflow-y: auto;

  @media (--only-desktop) {
    height: 428px;
  }

  @media (--to-desktop) {
    order: 2;
    width: 100%;
    height: 100%;
  }

  @media (--only-mobile) {
    padding: 16px;
  }
`;

export const ModalMediaCardBody: React.FC<ModalMediaCardBodyProps> = ({ children, className, title }) => (
  <StyledModalMediaCardBody className={className}>
    {title && (
      <SectionSubTitle adaptive={false} as="h3" margin="s" variant="h3">
        {title}
      </SectionSubTitle>
    )}
    {children}
  </StyledModalMediaCardBody>
);
